import { SearchFilterEnum } from 'api/actor';
import { ReferentialKey } from 'api/referential';
import { ComponentKey } from 'enums/componentKey';
import { PersonalInformationFieldNames } from 'features/new-actor/enums/personalInformationFieldNames';
import { InputsConfig } from 'types/form/inputsConfig';

export const personalInformationInputsConfig: InputsConfig<PersonalInformationFieldNames> =
{
  [PersonalInformationFieldNames.Civility]: {
    componentKey: ComponentKey.ReferentialDropdown,
    referentialKey: ReferentialKey.Civility,
    name: PersonalInformationFieldNames.Civility,
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.CIVILITY'
  },
  [PersonalInformationFieldNames.FirstName]: {
    componentKey: ComponentKey.InputText,
    name: PersonalInformationFieldNames.FirstName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.FIRST_NAME',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.FIRST_NAME'
  },
  [PersonalInformationFieldNames.LastName]: {
    componentKey: ComponentKey.InputText,
    name: PersonalInformationFieldNames.LastName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.LAST_NAME',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.LAST_NAME'
  },
  [PersonalInformationFieldNames.BirthName]: {
    componentKey: ComponentKey.InputText,
    name: PersonalInformationFieldNames.BirthName,
    type: 'text',
    required: false,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.BIRTH_NAME',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.BIRTH_NAME'
  },
  [PersonalInformationFieldNames.BirthDate]: {
    componentKey: ComponentKey.InputText,
    name: PersonalInformationFieldNames.BirthDate,
    type: 'date',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.DATE_OF_BIRTH',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.DATE_OF_BIRTH'
  },
  [PersonalInformationFieldNames.Nationality]: {
    componentKey: ComponentKey.ReferentialDropdown,
    referentialKey: ReferentialKey.Nationality,
    name: PersonalInformationFieldNames.Nationality,
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.NATIONALITY',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.NATIONALITY'
  },
  [PersonalInformationFieldNames.BirthCountry]: {
    componentKey: ComponentKey.ReferentialDropdown,
    referentialKey: ReferentialKey.Country,
    name: PersonalInformationFieldNames.BirthCountry,
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.BIRTH_COUNTRY',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.BIRTH_COUNTRY'
  },
  [PersonalInformationFieldNames.Phone]: {
    componentKey: ComponentKey.InputText,
    name: PersonalInformationFieldNames.Phone,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.PHONE',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.PHONE',
    existenceCheck: {
      enabled: true,
      type: 'phone',
      searchFilter: SearchFilterEnum.Phone,
      debounceMs: 800,
      errorMessage: 'Ce numéro de téléphone est déjà utilisé'
    }
  },
  [PersonalInformationFieldNames.Email]: {
    componentKey: ComponentKey.InputText,
    name: PersonalInformationFieldNames.Email,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.EMAIL',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.EMAIL',
    existenceCheck: {
      enabled: true,
      type: 'email',
      searchFilter: SearchFilterEnum.Email,
      debounceMs: 800,
      errorMessage: 'Cette adresse email est déjà utilisée'
    }
  },
  [PersonalInformationFieldNames.TaxResidenceCountryId]: {
    componentKey: ComponentKey.ReferentialDropdown,
    referentialKey: ReferentialKey.Country,
    name: PersonalInformationFieldNames.TaxResidenceCountryId,
    required: true,
    label: 'ACTOR_FORM.NATURAL_PERSON.LABELS.TAXRESIDENCE_COUNTRY',
    placeholder: 'ACTOR_FORM.NATURAL_PERSON.PLACEHOLDERS.TAXRESIDENCE_COUNTRY'
  },
  [PersonalInformationFieldNames.IsPPE]: {
    componentKey: ComponentKey.Checkbox,
    name: PersonalInformationFieldNames.IsPPE,
    label: 'ACTOR_FORM.NATURAL_PERSON.LABELS.IS_PPE',
    required: true
  },
  [PersonalInformationFieldNames.IsFPE]: {
    componentKey: ComponentKey.Checkbox,
    name: PersonalInformationFieldNames.IsFPE,
    label: 'ACTOR_FORM.NATURAL_PERSON.LABELS.IS_FPE',
    required: true
  }
};
